module.exports = __webpack_public_path__ + "img/2c.a22fea88.svg";